import {FormGroup} from '@angular/forms';

/**
 * Helper Class for FormGroup
 */
export class FormUtils {
  /**
   * Marks all controls in a FormGroup as touched
   * ==> method markAllAsTouched : Available in angular 8 or 8+ version in FormGroup.
   * @param {FormGroup} formGroup - The form group to touch
   * @public
   */
  public markAllAsTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();
      if (control.controls) {
        this.markAllAsTouched(control);
      }
    });
  }

  getDirtyValues(form: any) {
    const dirtyControls = {};
    const dirtyControlValues = {};

    Object.keys(form.controls)
      .forEach(key => {
        const currentControl = form.controls[key];

        if (currentControl.dirty) {
            dirtyControls[key] = currentControl.value;
        }
      });

    // tslint:disable-next-line:forin
    for (const controlName in dirtyControls) {
      dirtyControlValues[controlName] = form.get(controlName).getRawValue();
    }

    return dirtyControlValues;
  }
}
